var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRepeat03 = function SvgRepeat03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C2024",
    fillRule: "evenodd",
    d: "M10.293 1.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 1 1-1.414-1.414L11.586 6H9a6 6 0 0 0-2.57 11.423 1 1 0 0 1-.86 1.807A8 8 0 0 1 9 4h2.586l-1.293-1.293a1 1 0 0 1 0-1.414m6.804 3.952a1 1 0 0 1 1.332-.475A8 8 0 0 1 15 20h-2.585l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414L12.414 18H15a6 6 0 0 0 2.57-11.423 1 1 0 0 1-.473-1.332",
    clipRule: "evenodd"
  })));
};
export default SvgRepeat03;